
import { useMemo } from 'react'
import PropTypes from 'prop-types'
import { Bold, Overline } from '@panwds/react-ui'


import './FadedLineHeader.scss'

const FadedLineHeader = ({ title, position }) => {

  const rightWidth = useMemo(() => {
    switch (position) {
      case 'left':
        return null
      case 'right':
      case 'center':
      default:
        return '2%'
    }
  }, [position])

  const leftWidth = useMemo(() => {
    switch (position) {
      case 'right':
        return null
      case 'left':
      case 'center':
      default:
        return '99%'
    }
  }, [position])

  return <div className='tw-flex tw-flex-row tw-m-4 tw-items-center tw-justify-center'>
    <div className='cloud-mgm-fade-right' style={{ width: rightWidth }}/>
    <div><Overline size='sm'><Bold appearance='semibold' addClassName='tw-whitespace-nowrap'>{ title }</Bold></Overline></div>
    <div className='cloud-mgm-fade-left' style={{ width: leftWidth }}/>
  </div>
}

FadedLineHeader.propTypes = {
  title: PropTypes.string,
  position: PropTypes.oneOf([
    'left',
    'right',
    'center'
  ])
}

FadedLineHeader.defaultProps = {
  title: '',
  position: 'center'
}

export default FadedLineHeader
